import { AgGridReact } from 'ag-grid-react';
import { useEffect, useState } from 'react';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
ModuleRegistry.registerModules([AllCommunityModule]);

const ReportPreview = ({ refundReport }) => {
  const [columns, setColumns] = useState([]);
  useEffect(() => {
    setColumns(
      refundReport.length
        ? Object.keys(refundReport[0]).map((key) => {
            return {
              headerName: key,
              field: key,
              sortable: true,
            };
          })
        : [],
    );
  }, [refundReport]);

  return (
    <div
      className='ag-theme-alpine'
      style={{
        height: '100%',
        width: '100%',
      }}>
      <AgGridReact
        defaultColDef={{ resizable: true }}
        columnDefs={columns}
        rowData={refundReport}
        icons={{
          sortAscending:
            '<i style="font-size:8px;"  className="fa fa-sort-up">ASC</i>',
          sortDescending:
            '<i  style="font-size:8px;" className="fa fa-sort-down">DSC</i>',
        }}></AgGridReact>
    </div>
  );
};

export default ReportPreview;
